import { DisagreedQuestion } from './DisagreeAnswersList'

import { ActionAnswer } from 'src/api/quizzes/types'
import { QuizAnswers } from 'src/api/quizAnswers/types'

export const getSameAnswers = (
  quizAnswers: QuizAnswers,
  answer: ActionAnswer
) =>
  quizAnswers.myAnswers.reduce((acc, currentAnswer) => {
    const otherUserAnswer = quizAnswers.otherUserAnswers.find(
      ({ questionId }) => questionId === currentAnswer.questionId
    )

    if (otherUserAnswer?.answer === answer && currentAnswer.answer === answer) {
      return acc.concat(currentAnswer.questionTitle)
    }
    return acc
  }, [] as string[])

export const getDisagreedQuestions = (quizAnswers: QuizAnswers) =>
  quizAnswers.myAnswers.reduce((acc, currentAnswer) => {
    const otherUserAnswer = quizAnswers.otherUserAnswers.find(
      ({ questionId }) => questionId === currentAnswer.questionId
    )

    if (
      otherUserAnswer &&
      otherUserAnswer.answer !== currentAnswer.answer &&
      currentAnswer.answer !== ActionAnswer.skip &&
      otherUserAnswer.answer !== ActionAnswer.skip
    ) {
      return acc.concat({
        userAnswer: currentAnswer.answer,
        otherUserAnswer: otherUserAnswer.answer,
        title: currentAnswer.questionTitle,
      })
    }
    return acc
  }, [] as DisagreedQuestion[])
